<app-bottom-sheet height="88vh">
    <ng-container header>
        <h5>{{ 'generic.filters' | translate }}</h5>
    </ng-container>
    <ng-container content>
        <form class="filters" [formGroup]="filterForm">
            <ng-container *ngIf="availableStatuses && availableStatuses.length">
                <h5>{{ 'lift-operator.incoming-tool-request.filters.status' | translate }}</h5>
                <ng-container *ngFor="let status of availableStatuses">
                    <app-input-radio
                        group="status"
                        [label]="status"
                        [value]="status === 'All' ? null : status"
                        [formControl]="filterForm.controls.status">
                    </app-input-radio>
                </ng-container>
            </ng-container>

            <ng-container *ngIf="availableTypes && availableTypes.length">
                <h5>{{ 'lift-operator.incoming-tool-request.filters.type' | translate }}</h5>
                <ng-container *ngFor="let type of availableTypes">
                    <app-input-radio
                        group="type"
                        [label]="type"
                        [value]="type === 'All' ? null : type"
                        [formControl]="filterForm.controls.type">
                    </app-input-radio>
                </ng-container>
            </ng-container>

            <ng-container *ngIf="availableLines && availableLines.length">
                <h5>{{ 'lift-operator.incoming-tool-request.filters.line' | translate }}</h5>
                <ng-container *ngFor="let line of availableLines">
                    <app-input-radio
                        group="line"
                        [label]="line?.name"
                        [value]="line?.id"
                        [formControl]="filterForm.controls.lineId">
                    </app-input-radio>
                </ng-container>
            </ng-container>
        </form>
    </ng-container>
    <ng-container footer>
        <app-button type="primary" (click)="onApply()">
            {{ 'generic.buttons.apply' | translate }}
        </app-button>
    </ng-container>
</app-bottom-sheet>
